<template>
  <div class="maps">
    WORK IN PROGRESS - KNOWN ISSUES USING WEBPACK AND LEAFLET<br>
    <!-- <l-map
      style="height: 100%; width:100%"
      :zoom="zoom"
      :center="center">
      <l-tile-layer
        :url="url"
        :attribution="attribution" />
      <l-marker
      :lat-lng="marker" />
    </l-map> -->
  </div>
</template>
<script>
// var Vue = require('vue/dist/vue.js');
// import vis from 'vis';
import { SocketHandler, LifeCycle } from '@/assets/javascript/mixins/Mixins'
// import {LMap, LTileLayer, LMarker} from 'vue2-leaflet' // eslint-disable-line no-use-before-define
export default
{
  name: 'Maps',
  components:
  {
    // 'about-component': About,
    // 'ag-grid': AgGrid,
    // 'vis': vis
    // LMap, LTileLayer, LMarker
  },
  mixins: [SocketHandler, LifeCycle],
  props:
  {
    SocketMessage:
    {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return{
      showAboutModal: false,
      componentName: '',
      waterDailyData: [],
      container: '',
      timeline: '',
      items: '',
      options: '',
      modalOpen: false,
      waterInfo: {},
      zoom: 10,
      center: [55.994434, 12.499353],
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      marker: [55.994434, 12.499353]
    }
  },
  watch: {},
  mounted() {
    setTimeout(function() {
      window.dispatchEvent(new Event('resize'))
    }, 250)
    // this.componentName = 'Map';
    // this.serverRequestNGIC({'component': 'History', 'command': 'Mounted'});
    // sessionStorage.setItem('route', this.$router.currentRoute.path);
    this.SocketMessageSend({component: 'Maps', command: 'Mounted'})

    this.$nextTick(() => {
      this.$emit('SetPageMessage', {
        target: 'FooterButtons',
        data: [{
          label: this.$tc('messages.sharedTexts.stations.station', 0),
          route: '/stations',
          className: 'ButtonLeft'
        },
        {
          label: this.$t('messages.footer.stationSurvey'),
          route: '/survey',
          className: 'ButtonLeft'
        },
        {
          label: this.$t('messages.footer.sensorList'),
          route: '/sensors',
          className: 'ButtonLeft'
        }]
      })
    })
  },
  methods:
  {
    logoutUser() {
      this.$router.push('/login')
    },
    deviceList() {
      this.$router.push('/devicelist')
    },
    updateShowAboutModal() {
      this.showAboutModal = false
    },
    aboutFn() {
      this.showAboutModal = true
    }
  }
}
</script>
<style>
.maps
{
  position: relative;
  width: 95%;
  max-width: 1120px;
  height: 95%;
  max-height: 557px;
  margin: 100px auto;
  border: 1px solid green;
  background-image: url('~@graphics/mapDemo.png');
  background-size: cover;
}

l-map
{
  position: absolute;
}
</style>
